import React, { useEffect } from 'react'
import { Container, Typography, Button } from '@mui/material';
import AOS from 'aos';
import Preloader from '../../../common/Preloader';
import { Link } from "react-router-dom";
import RawMarkup from '../../../common/RawMarkup'

const DiscoverySection = ({data}) => {

  useEffect(() => { AOS.init({ duration: 800, offset: 100 }); }, []);

  if (!data) { return ( <Preloader /> );  }

  const { title = "", description = "", button_link="#", button_text=""  } = data || {};
    
  return (
    <Container maxWidth="md" sx={{ py: {xs: 2, md:16}, px: {xs: 2, md:3}, textAlign: 'center', }}  >
      <Typography variant="h3" className='homepage-section-title' sx={{fontSize: {xs:'1.8rem', md:'2.25rem'}, mb: 3}} data-aos="fade-up">
        {title}
      </Typography>
      <Typography variant="body1" sx={{ mb: 3, color: '#666', fontSize: '1.25rem' }} data-aos="fade-up">
        <RawMarkup content={description} />
      </Typography>
      <Button variant="contained" data-aos="fade-up" component={Link} to={button_link}>
        {button_text}
      </Button>
    </Container>
  );
};

export default DiscoverySection;
